import React from 'react';
import { ThemeString } from '../types/Theme';
import { PaymentMethodsList } from '../components/PaymentMethodsList';
import { bnplPayload } from './sampleData/bnplPayload';

export interface PaymentMethodsBannerDemoProps {
  theme?: ThemeString;
}

export const PaymentMethodsBannerDemo: React.FC<PaymentMethodsBannerDemoProps> = ({ theme = 'light' }) => {
  return (
    <div>
      <PaymentMethodsList
        bnplMethods={bnplPayload}
        amount="400"
        currency="USD"
        theme={theme}
        publicBaseUrl=""
        locale="en"
        country="USA"
        openModal={() => {}}
      />
    </div>
  );
};
